import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPencilIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#999"
      fillRule="evenodd"
      d="M2.5 14.55v2.533c0 .234.183.417.417.417H5.45a.4.4 0 0 0 .292-.125l9.1-9.092-3.125-3.125-9.092 9.092a.4.4 0 0 0-.125.3m14.758-8.683a.83.83 0 0 0 0-1.175l-1.95-1.95a.83.83 0 0 0-1.175 0l-1.525 1.525 3.125 3.125z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPencilIcon;
